import React, { useState } from 'react';
import { nanoid } from 'nanoid';

import Plus from 'icons/plus.svg';
import Minus from 'icons/minus.svg';
import { FAQMeta } from 'interfaces';

import { Title } from './Title';

type ItemType = {
  question: string;
  answer: string;
  content?: string;
};

const AccordionFAQContent = ({ question, answer, content }: ItemType) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="accordion-item">
      <div className="accordion-title-wrap" onClick={() => setOpen(!open)}>
        <div className="accordion-icon accordion-icon-faqs">{open ? <Minus /> : <Plus />}</div>
        <h4 className="accordion-faqs-title">{question}</h4>
      </div>
      {open ? (
        <div className="accordion-content">
          {answer && <p>{answer}</p>}
          {content && (
            <div
              key={nanoid()}
              className="blog-portfolio-paragraphs"
              dangerouslySetInnerHTML={{ __html: content || '' }}
            />
          )}
        </div>
      ) : null}
    </div>
  );
};

export interface TextProps {
  node: {
    faq?: FAQMeta[];
    fieldTitle: string;
    titleLevel?: number;
  };
}

export const FAQ = ({ node }: TextProps) => {
  const { fieldTitle, titleLevel, faq } = node;

  return (
    <div className="accordion accordion-faqs">
      <Title title={fieldTitle} titleLevel={titleLevel} />
      {faq?.map(({ question, answer, content }) => (
        <AccordionFAQContent question={question} answer={answer} content={content} key={nanoid()} />
      ))}
    </div>
  );
};
